import React from 'react'
import CaseViolationItem from './CaseViolationItem'

const CaseCitation = ({ citation }) => {
  return (
    <div>
      <CaseViolationItem citation={citation} key={`citation_${citation.id}`} />
    </div>
  )
}

export default CaseCitation
